import {FormDrawer} from "./FormDrawer.tsx";
import {DrawerProps} from "@mantine/core";
import {useParams} from "react-router-dom";
import {useOrder} from "../hooks/useOrder.ts";

export const AddFormDrawer = (props: DrawerProps) => {
    const {id: customerId} = useParams();
    if (!customerId) throw new Error('customerId is required');

    const {createRecord} = useOrder();

    // No `id`: CreateOrderInput does not declare one. The service whitelists the input; a
    // create still lacks providerKey/amount/currency (FNP-1912).
    return (
        <FormDrawer
            record={{
                customerId,
                subscriptionId: '',
            }}
            handleSubmit={createRecord}
            {...props}
        />
    )
};
